// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"725":"4b75b82c","881":"b06ae6cd","908":"fc8850d1"}[chunkId] + ".chunk.js";
};